import { render, staticRenderFns } from "./homeimg.vue?vue&type=template&id=6344489a&scoped=true&"
import script from "./homeimg.vue?vue&type=script&lang=js&"
export * from "./homeimg.vue?vue&type=script&lang=js&"
import style0 from "./homeimg.vue?vue&type=style&index=0&id=6344489a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6344489a",
  null
  
)

export default component.exports